<template>
	<div class="row">
		<small class="col-md-8 text-muted">
			{{ title }}
		</small>
		<div class="col-md-4 text-muted text-end color-gray">{{ pre }} {{ currency_output_symbol }}{{ changed_currency }}</div>
		<!-- {{ this.$store.state.currency_output }} -->
	</div>
</template>

<script>
export default {
	props: ["title", "value", "pre"],
	computed: {
		changed_currency: function () {
			let value = this.value / this.$store.state.currencies[this.$store.state.currency_for_calculate_taxes];
			return this.round(value * this.$store.state.currencies[this.$store.state.currency_output]);
		},
		currency_output_symbol: function () {
			let object = this.$store.state.currencies_list.find((element) => element.value === this.$store.state.currency_output);
			if (object) {
				return object.symbol;
			}
		},
	},
	methods: {
		round(val) {
			return val.toLocaleString("usa", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			// return Math.round(val);
		},
	},
};
</script>
